<template>
  <div>

    <modal
      :title="$t('titles.are_you_sure')"
      :submit="() => closeDialog(true)"
      :submit-label="$t('actions.proceed')"
    >

      <p>You have unsaved changes that will be lost.</p>

    </modal>

  </div>
</template>

<script setup lang="ts">

// @ts-ignore
import { closeDialog } from 'vue3-promise-dialog'

</script>
